import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Favorite } from './Favorite';

export const FavoriteEvent = inject('me')(
  observer(({ me, eventId, size, className }) => (
    <Favorite
      size={size}
      className={className}
      checked={me.isFavorite('events', eventId)}
      onCheck={(checked) => me.setFavorite('events', eventId, checked)}
    />
  ))
);

FavoriteEvent.propTypes = {
  eventId: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
};
